import * as React from 'react';
import { ZeroSignalTooltipContent } from './zeroSignal';
import { NoServiceTooltipContent } from './noService';
import { CoverageTooltipContent } from './coverage';
import { IntensityMap } from './shared/index';
import { getNoServiceIntensity, getZeroSignalLevelIntensity, getCoverageIntensity } from '../../../services/core/maps';
import { getTimePeriodParams } from '@lib/dateParams';

export enum MapData {
  poorNoSignal = 'VERY_POOR_NO_SERVICE',
  noService = 'NO_SERVICE',
  coverage = 'COVERAGE',
}

type DeviceServiceProps = {
  deviceId: string,
  mapData: MapData,
  timePeriod: number,
  bearerType?: string
};

export const DeviceServiceMap: React.FC<DeviceServiceProps> = ({ deviceId, mapData, timePeriod, bearerType }) => {
  const fetchNoServiceMapData = React.useCallback((boundingLatLong: string, geotilePrecision: number) => {
    return getNoServiceIntensity({
      boundingLatLong,
      geotilePrecision,
      deviceId,
      ...getTimePeriodParams(timePeriod),
    });
  }, [deviceId, timePeriod]);

  const fetchZeroSignalMapData = React.useCallback((boundingLatLong: string, geotilePrecision: number) => {
    return getZeroSignalLevelIntensity({
      boundingLatLong,
      geotilePrecision,
      deviceId,
      ...getTimePeriodParams(timePeriod),
    });
  }, [deviceId, timePeriod]);

  const fetchCoverageMapData = React.useCallback((boundingLatLong: string, geotilePrecision: number) => {
    return getCoverageIntensity({
      boundingLatLong,
      geotilePrecision,
      deviceId,
      ...getTimePeriodParams(timePeriod),
      bearerType
    });
  }, [deviceId, timePeriod, bearerType]);

  if (mapData === MapData.noService) {
    return <IntensityMap
      deviceId={deviceId}
      fetchMapData={fetchNoServiceMapData}
      TooltipContent={NoServiceTooltipContent}
    />;
  } else if (mapData === MapData.coverage) {
    return <IntensityMap
      deviceId={deviceId}
      fetchMapData={fetchCoverageMapData}
      TooltipContent={CoverageTooltipContent}
      colorVariant='neutral'
    />;
  } else {
    return <IntensityMap
      deviceId={deviceId}
      fetchMapData={fetchZeroSignalMapData}
      TooltipContent={ZeroSignalTooltipContent}
    />;
  }
};
